// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".van-uploader__input-wrapper[data-v-123fb708] {\n  width: 100%;\n  position: relative;\n}\n.dialog_content[data-v-123fb708] {\n  padding: 0;\n  text-align: center;\n  overflow: hidden;\n}\n.down_img[data-v-123fb708] {\n  width: 100%;\n  height: 45vh;\n}", ""]);
// Exports
module.exports = exports;
